import React from 'react';
import { useAgent } from '../AgentsContext';

const AgentSelector: React.FC = () => {
    const { agents, selectedAgent, setSelectedAgent, loading } = useAgent();  

    const handleChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
        const newSelectedAgentId = event.target.value;
        setSelectedAgent(newSelectedAgentId);
    };

    return (
        <div className='flex flex-col items-center'>
            <p className='text-lg'>
                Select an agent:
            </p>
            <select
                value={selectedAgent || ''}  // Default to empty string if selectedAgent is null or undefined
                onChange={handleChange}
                className="p-2 pl-4 pr-10 m-2 ml-auto mr-auto bg-white dark:bg-gray-700 border border-gray-300 dark:border-gray-800 rounded-md hover:bg-gray-300 dark:hover:bg-gray-600 focus:outline-none focus:ring-2 focus:ring-blue-500 text-lg"
                disabled={loading}
            >
                {loading ? (
                    <option value="" disabled>Loading...</option>
                ) : agents.length > 0 ? (
                    [...agents].sort((a, b) => a.name.localeCompare(b.name)).map((agent) => (
                        <option key={agent.id} value={agent.id}>
                            {agent.name}
                        </option>
                    ))
                ) : (
                    <option value="" disabled>No agents available</option>
                )}
            </select>
        </div>
    );
};

export default AgentSelector;
